import { Tooltip } from '@ds';
import { FC, PropsWithChildren } from 'react';
import { useIsTruncated } from '@/hooks/useIsTruncated';

export type CasesBoardColumnHeaderProps = PropsWithChildren<{
  title: string;
  amount?: number;
  isRows?: boolean;
}>;

export const CasesBoardColumnHeader: FC<CasesBoardColumnHeaderProps> = ({ title, amount, isRows, children }) => {
  const { ref, isTruncated } = useIsTruncated<HTMLParagraphElement>();

  const containerClass = `flex items-center gap-2 ${!isRows ? 'max-w-[292px]' : ''}`;
  const titleClass = `text-l-cps text-base-10 ${isRows ? 'whitespace-normal' : 'whitespace-nowrap overflow-hidden text-ellipsis'}`;

  const titleElement = (
    <p ref={!isRows ? ref : undefined} className={titleClass}>
      {title}
    </p>
  );

  return (
    <div className="flex justify-between items-center pb-2 pr-2">
      <div className={containerClass}>
        {!isRows && isTruncated ? (
          <Tooltip content={title} placement="top" delay={300}>
            {titleElement}
          </Tooltip>
        ) : (
          titleElement
        )}
        {amount !== undefined && <span className="text-l-sb text-black">{amount}</span>}
      </div>
      {children}
    </div>
  );
};
